/// <amd-module name="Repos/Views/ProjectPolicies/Components/ProjectPoliciesShim" />
import * as React from "react";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { ProjectPoliciesView } from "./ProjectPoliciesView";
import { parseQueryString, Uri } from "VSS/Platform/Util/Url";

const AdminPoliciesContributionId = "ms.vss-code-web.admin-policies-data-provider";

export class ProjectPoliciesShim extends VssComponent<{}, {}> {
    private isEditingProjectScope: boolean;

    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        const contributionService = context.pageContext.getService<IVssContributionService>("IVssContributionService");

        const pageData = contributionService.getData<any>(AdminPoliciesContributionId, {});

        this.isEditingProjectScope = pageData != null && pageData.invalidScope === false;
    }

    public render(): JSX.Element {
        if (this.isEditingProjectScope) {
            return (
                <LegacyComponent
                    modules={["Policy/Scenarios/AdminPolicies/AdminPoliciesHub"]}
                    wrappedType="AdminPoliciesHubComponentWrapper"
                    wrappedProps={{
                        hello: "world"
                    }}
                />
            );
        } else {
            return <ProjectPoliciesView />;
        }
    }
}

Components.add("project-policies-shim", ProjectPoliciesShim);
